export default __webpack_public_path__ + "static/media/PK.439c85cc.svg";